export enum InvoiceTemplateArchivedFilter {
    ACTIVE = "active",
    ALL = "all",
    ARCHIVED = "archived",
}

export enum InvoiceTemplateSort {
    NAME_ASC = "name_asc",
    NAME_DESC = "name_desc",
    CUSTOMER_ASC = "customer_asc",
    CUSTOMER_DESC = "customer_desc",
    ENTITY_ASC = "entity_asc",
    ENTITY_DESC = "entity_desc",
    TOTAL_ASC = "total_asc",
    TOTAL_DESC = "total_desc",
    INVOICES_ASC = "invoices_asc",
    INVOICES_DESC = "invoices_desc",
    LAST_USED_AT_ASC = "last_used_at_asc",
    LAST_USED_AT_DESC = "last_used_at_desc",
    CREATED_AT_ASC = "created_at_asc",
    CREATED_AT_DESC = "created_at_desc",
    UPDATED_AT_ASC = "updated_at_asc",
    UPDATED_AT_DESC = "updated_at_desc",
    ARCHIVED_AT_ASC = "archived_at_asc",
    ARCHIVED_AT_DESC = "archived_at_desc",
}

export const DEFAULT_INVOICE_TEMPLATE_SORT =
    InvoiceTemplateSort.UPDATED_AT_DESC;

export interface InvoiceTemplateBase {
    id: string;
    entityId: number;
    name: string;
    archivedAt: Date | null;
    createdByUserId: number | null;
    createdAt: Date;
    updatedByUserId: number | null;
    updatedAt: Date;
    archivedByUserId: number | null;
}
